import { WebPlugin } from '@capacitor/core';
export class AppReviewWeb extends WebPlugin {
    request() {
        return Promise.resolve();
    }
    openStore() {
        return Promise.resolve();
    }
}
//# sourceMappingURL=web.js.map